import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

export type Data = OopsyData;

// Ruby Normal
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.CinderDrift,
  damageWarn: {
    'Ruby Ravensclaw': '4A93', // centered circle aoe for ravensclaw
    'Ruby Spike Of Flame 1': '4A9A', // initial explosion during helicoclaw
    'Ruby Spike Of Flame 2': '4B2E', // followup helicoclaw explosions
    'Ruby Spike Of Flame 3': '4A94', // ravensclaw explosion at ends of lines
    'Ruby Spike Of Flame 4': '4A95', // ravensclaw explosion at ends of lines
    'Ruby Spike Of Flame 5': '4D02', // ravensclaw explosion at ends of lines
    'Ruby Spike Of Flame 6': '4D03', // ravensclaw explosion at ends of lines
    'Ruby Ruby Ray': '4AC6', // frontal laser
    'Ruby Undermine': '4A97', // ground aoes under the ravensclaw patches
    'Ruby Ravensflight 1': '4E69', // dash around the arena
    'Ruby Ravensflight 2': '4E6A', // dash around the arena
    'Ruby Ravensflight 3': '4AA1', // dash around the arena
    'Ruby Ravensflight 4': '4AA2', // dash around the arena
    'Ruby Ravensflight 5': '4AA3', // dash around the arena
    'Ruby Ravensflight 6': '4AA4', // dash around the arena
    'Ruby Ravensflight 7': '4AA5', // dash around the arena
    'Ruby Ravensflight 8': '4AA6', // dash around the arena
    'Ruby Ravensflight 9': '4AA7', // dash around the arena
    'Ruby Ravensflight 10': '4C21', // dash around the arena
    'Ruby Ravensflight 11': '4C2A', // dash around the arena
    'Ruby Comet Burst': '4AB4', // meteor exploding
    'Ruby Bradamante': '4ABC', // headmarkers with line aoes
  },
  shareWarn: {
    'Ruby Homing Laser': '4AC5', // spread markers in P1
    'Ruby Meteor Stream': '4E67', // spread markers in P2
  },
};

export default triggerSet;
